<template>
  <div v-if="visible" id="common-menu-drawer">
    <div class="common-menu-drawer-menu">
      <div v-html="html"></div>
    </div>
    <div class="common-menu-drawer-mask" @click="close"></div>
  </div>
</template>

<script>
import { getMenu } from "@/services/common-menu";
export default {
  name: "CommonMenu",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      html: "",
    };
  },
  mounted() {
    getMenu().then((res) => {
      this.html = res.data;
    });
  },
  methods: {
    close() {
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style lang="scss" scoped></style>
